<script>
import BasePopup from '@/components/BasePopup.vue';
import BaseInput from '@/components/BaseInput.vue';
import BaseStatusColorPicker from '@/components/base/BaseStatusColorPicker.vue';

export default {
  name: 'BaseStatusForm',
  components: { BasePopup, BaseInput, BaseStatusColorPicker },
  controller: null,
  props: {
    usedColors: Array,
  },
  data() {
    return {
      isOpened: false,
      name: '',
      color: null,
      nameError: '',
      colorError: '',
      title: '',
      excludedColor: '',
    };
  },
  computed: {
    usedColorsExceptCurrent() { return this.usedColors.filter(c => c !== this.excludedColor) },
  },
  methods: {
    open(name = null, color = null) {
      this.isOpened = true;
      this.name = name;
      this.color = color;
      document.body.style.overflow = 'hidden';

      if (this.color) {
        this.excludedColor = this.color;
      }

      this.title = name ? 'Редактирование статуса' : 'Создание статуса';

      return new Promise((resolve, reject) => {
        this.$options.controller = { resolve, reject };
      });
    },
    save() {
      this.nameError = this.name ? '' : 'Укажите название статуса';
      this.colorError = this.color ? '' : 'Укажите цвет статуса';

      if (this.nameError || this.colorError) return;

      this.close(true);
    },
    close(result) {
      this.isOpened = false;
      const { name, color } = this;
      const answer = result ? { name, color } : null;
      this.$options.controller.resolve(answer);
      document.body.style.overflow = 'visible';
    },
  },
};
</script>

<template lang="pug">
  BasePopup(@close="close(false)" v-if="isOpened" :zIndex="999999999")
    .b-status-color-picker
      ._title {{ title }}
      BaseInput._input(v-model="name" label="Наименование статуса" :error="nameError" @input="nameError = ''")
      ._color-err(v-if="colorError") {{ colorError }}
      BaseStatusColorPicker._color-picker(v-model="color" :used="usedColorsExceptCurrent" @change="colorError = ''")
      ._buttons
        Btn(blue @click="save") OK
        Btn(grey @click="close(false)") Отмена
</template>

<style scoped lang="scss">
.status-color-picker {
  &__title {
    font-weight: bold;
    font-size: 18px;
    line-height: 24px;
    text-align: center;
    letter-spacing: 0.02em;
    margin-bottom: 40px;
    color: #4A535C;
  }

  &__input {
    margin-bottom: 30px;
  }

  &__color-picker {
    margin-bottom: 30px;
  }

  &__color-err {
    color: var(--color-red) !important;
    letter-spacing: 0.01em;
    font-weight: 500;
    line-height: 13px;
    font-size: 10px;
    //padding: 0 16px;
    margin-bottom: 10px;
  }

  &__buttons {
    display: flex;
    justify-content: center;
    gap: 30px;
  }
}
</style>
